import axios from 'axios';
import querystring from 'query-string';
import Cookies from 'js-cookie';

const COOKIE_NAME = 'SUBSCRIBED';
const COOKIE_EXPIRATION = 365;

const endpoint = 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe';

const timezoneOffset = -(new Date().getTimezoneOffset() / 60);

const submitRequest = function submitKlaviyoRequest(postData) {
  return axios.post(
    endpoint,
    querystring.stringify(postData),
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Cache-Control': 'no-store',
        Pragma: 'no-cache',
      },
    },
  );
};

const subscribe = function subscribeUserEmail(props = {}) {
  const {
    listId = '',
    email = '',
    source = 'Website',
  } = props;

  const klaviyoId = window.settings && window.settings.klaviyo_list_id
    ? window.settings.klaviyo_list_id
    : '';
  const g = listId || klaviyoId;

  return new Promise((resolve, reject) => {
    const postData = {
      email,
      g,
      $consent: 'email',
      $fields: '$consent,$source,Interested In',
      $list_fields: '$consent',
      $source: source,
      $timezone_offset: timezoneOffset,
    };

    if (!g || !email) {
      reject(new Error('Required settings missing'));
    }

    submitRequest(postData)
      .then((response) => {
        const hasError = response.data
          && response.data.errors
          && response.data.errors.length;

        if (!hasError) {
          Cookies.set(COOKIE_NAME, 1, { expires: COOKIE_EXPIRATION });
        }

        return response;
      })
      .then(resolve)
      .catch(reject);
  });
};

const getIsSubscribed = () => Cookies.get(COOKIE_NAME);

export default {
  getIsSubscribed,
  subscribe,
};
